import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=af80c0ca&scoped=true&"
import script from "./DropdownItem.vue?vue&type=script&lang=ts&"
export * from "./DropdownItem.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=af80c0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af80c0ca",
  null
  
)

export default component.exports